import { render } from "./DocumentPreview.vue?vue&type=template&id=314d3c4b&scoped=true&ts=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=ts"
export * from "./DocumentPreview.vue?vue&type=script&lang=ts"

import "./DocumentPreview.vue?vue&type=style&index=0&id=314d3c4b&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314d3c4b"]])

export default __exports__